import { useNavigate, useParams } from "react-router";
import { SceneEditor } from "../components/editors/SceneEditor";

export function ScenePage() {
  const { storyId = "", chapterId = "", sceneId = "" } = useParams();
  const navigate = useNavigate();
  return (
    <SceneEditor
      storyId={storyId}
      chapterId={chapterId}
      sceneId={sceneId}
      onDeleted={() => navigate(`/stories/${storyId}/chapters/${chapterId}`, { replace: true })}
    />
  );
}
